"use client";
import { isEmptyFilterAtom } from "@/hooks/useCurrentFilters";
import { useAtom } from "jotai";
import { PropsWithChildren } from "react";
import EmptyCategory from "./EmptyCategory";

interface Props {
  productNum: number;
}
const CategoryProductsContainer: React.FC<PropsWithChildren<Props>> = ({
  productNum,
  children,
}) => {
  const [isEmptyFilter] = useAtom(isEmptyFilterAtom);
  if (isEmptyFilter && productNum === 0) return <EmptyCategory />;

  return <>{children}</>;
};

export default CategoryProductsContainer;
